import { MapPin, Clock, DollarSign, ExternalLink } from "lucide-react";

const TYPE_COLORS = {
  tournament: "bg-red-500",
  camp: "bg-green-500",
  clinic: "bg-gray-700",
  league: "bg-purple-500",
  social: "bg-orange-500",
};

const LOCATION_LABELS = { both: "Both Locations", baltimore: "Baltimore", princeton: "Princeton" };

const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  return { day: date.getDate(), month: date.toLocaleString("default", { month: "short" }).toUpperCase() };
};

export const EventCard = ({ event }) => {
  const date = formatDate(event.date);
  return (
    <div className="bg-[#111] border border-[#222] rounded-sm p-6 flex flex-col md:flex-row gap-6 card-hover" data-testid={`event-${event.id}`}>
      <div className="w-20 h-20 bg-[#1D1F21] rounded-sm flex flex-col items-center justify-center flex-shrink-0">
        <span className="text-xs font-bold text-[#F2EDE4]">{date.month}</span>
        <span className="text-3xl font-bold text-[#F2EDE4]">{date.day}</span>
      </div>
      <div className="flex-1">
        <div className="flex items-center gap-2 mb-2">
          <span className={`w-2 h-2 rounded-full ${TYPE_COLORS[event.event_type] || "bg-[#0D6B56]"}`}></span>
          <span className="text-xs font-semibold text-[#F2EDE4]/30 uppercase">{event.event_type}</span>
        </div>
        <h3 className="font-display text-xl font-bold text-[#F2EDE4] mb-2">{event.title}</h3>
        <p className="text-[#F2EDE4]/40 text-sm mb-4">{event.description}</p>
        <div className="flex flex-wrap gap-4 text-sm text-[#F2EDE4]/30">
          <div className="flex items-center gap-1"><Clock className="w-4 h-4" /><span>{event.time}</span></div>
          <div className="flex items-center gap-1"><MapPin className="w-4 h-4" /><span className="capitalize">{LOCATION_LABELS[event.location] || event.location}</span></div>
          {event.price && <div className="flex items-center gap-1"><DollarSign className="w-4 h-4" /><span>{event.price}</span></div>}
        </div>
      </div>
      {event.registration_url && (
        <div className="flex items-center">
          <a href={event.registration_url} className="btn-primary text-sm py-3 px-6 inline-flex items-center gap-2" data-testid={`event-register-${event.id}`}>
            Register <ExternalLink className="w-4 h-4" />
          </a>
        </div>
      )}
    </div>
  );
};

export default EventCard;
